/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantTagKeyValueQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TenantTagKeyValueQueryOperator");
    }

    getFixupPrototypeFunction() { return TenantTagKeyValueQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TenantTagKeyValueQueryOperator>): TenantTagKeyValueQueryOperator {
        let obj = Object.assign(new TenantTagKeyValueQueryOperator(), model);
        TenantTagKeyValueQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantTagKeyValueQueryOperator>): TenantTagKeyValueQueryOperator {
        if (!model) return null;
        return TenantTagKeyValueQueryOperator.newInstance(<TenantTagKeyValueQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantTagKeyValueQueryOperator) {
        if (!obj) return;

        models.TenantTagKeyValueQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantTagKeyValueQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TenantTagKeyValueQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tag key for the given tenant
     */
    tag_key: string;

    /**
     * Tag values for the given key
     */
    tag_values: Array<string>;

}
